<mat-dialog-content class="mat-typography" style="margin: 0;padding: 0;">
    <div fxLayout="row" fxLayoutAlign="space-between center"
        style="padding: 27px 32px; border-bottom: 1px solid rgba(222, 222, 222, 0.4)">
        <h2>Upload a New Document</h2>
        <button mat-icon-button mat-dialog-close>
            <mat-icon style="color: #DEDEDE;">close</mat-icon>
        </button>
    </div>
    <div>
        <div class="attachmentsOfTerms" style="padding: 32px; border-bottom:0.5px solid rgba(222, 222, 222, 0.2);">
            <div style="display: flex; flex-direction: row; align-items: center; margin-bottom: 16px;">
                <span style="margin-right: 8px; font-size: 16px;">Upload private documents (e.g. EOI Template)</span>
                <mat-icon [tooltipTriggerFor]="privateTooltip"
                          style="
                    font-size: 18px;
                    width: 18px;
                    height: 18px;
                    color: var(--primary-color);
                    cursor: pointer;">
                    contact_support
                </mat-icon>
                <tooltip #privateTooltip="tooltip">
                    <div class="tooltip-content" style="font-size: 14px;" fxLayout="column">
                        Only agents who have been approved to sell the project can view/download these documents
                    </div>
                </tooltip>
            </div>
            <div class="form-group">
                <input #termsInput style="display: none" type="file" multiple=""
                    (change)="onFileChangeForTerms($event)">
                <button (click)="termsInput.click()" mat-button
                    style="border: 1px solid #bababa; margin-bottom: 20px;width: 100%;"
                    *ngIf="selectedTermsAttachments.length == 0">
                    Click here to select a file
                </button>
                <button mat-button style="margin-bottom: 20px;width: 100%;background: #2142FF;"
                    *ngIf="selectedTermsAttachments.length > 0">
                    Your file has been successfully uploaded<span> <img src="./assets/images/black/checked.png"
                            style="width: 14px;margin-left: 5px;"> </span>
                </button>

                <p *ngIf="isTermsTooLarge === true"
                    style="color: #f44336; font-size: 14px; margin-top: 0; margin-bottom: 20px">File size cannot exceed
                    40MB.</p>
            </div>
            <div class="flex justify-between">
                <div>
                    <ng-container *ngIf="selectedTermsAttachments.length == 0">
                        <p>Max file size is 40mb</p>
                    </ng-container>
                    <ng-container *ngIf="selectedTermsAttachments.length > 0">
                        <p *ngFor="let file of selectedTermsAttachments"
                            style="display: flex; align-items: center; margin-top: 0px">
                            <mat-icon style="color: #b7b7b7; margin-right: 5px">insert_drive_file</mat-icon>
                            {{file.name}} ({{(file.size / 1098304).toFixed(2)}} MB)
                        </p>
                    </ng-container>
                </div>
                <div>
                    <p (click)="removeTermsAttachment()"
                        style="color: rgba(222, 222, 222, 0.6);font-size: 10px;text-decoration-line: underline;cursor: pointer;">
                        Remove file</p>
                </div>
            </div>

        </div>

        <div class="attachmentsOfProject" style="padding: 32px; border-bottom:0.5px solid rgba(222, 222, 222, 0.2);">
            <div style="display: flex; flex-direction: row; align-items: center; margin-bottom: 16px;">
                <span style="margin-right: 8px; font-size: 16px;">Upload public documents (e.g. brochure, floorplans)</span>
                <mat-icon [tooltipTriggerFor]="publicTooltip"
                          style="
                    font-size: 18px;
                    width: 18px;
                    height: 18px;
                    color: var(--primary-color);
                    cursor: pointer;">
                    contact_support
                </mat-icon>
                <tooltip #publicTooltip="tooltip">
                    <div class="tooltip-content" style="font-size: 14px;" fxLayout="column">
                        All agents and potential buyers can view/download these documents
                    </div>
                </tooltip>
            </div>
            <div class="form-group">
                <input #projectInput style="display: none" type="file" multiple=""
                    (change)="onFileChangeForProject($event)">
                <button (click)="projectInput.click()" mat-button
                    style="border: 1px solid #bababa;margin-bottom: 20px;width: 100%;"
                    *ngIf="selectedProjectAttachments.length == 0">
                    Click here to select a file
                </button>
                <button mat-button style="margin-bottom: 20px;width: 100%;background: #2142FF;"
                    *ngIf="selectedProjectAttachments.length > 0">
                    Your file has been successfully uploaded<span> <img src="./assets/images/black/checked.png"
                            style="width: 14px;margin-left: 5px;"> </span>
                </button>
            </div>

            <div class="flex justify-between">
                <div>
                    <ng-container *ngIf="selectedProjectAttachments.length == 0">
                        <p>Max file size is 40mb</p>
                    </ng-container>
                    <ng-container *ngIf="selectedProjectAttachments.length > 0">
                        <p *ngFor="let file of selectedProjectAttachments"
                            style="display: flex; align-items: center; margin-top: 0px">
                            <mat-icon style="color: #b7b7b7; margin-right: 5px">insert_drive_file</mat-icon>
                            {{file.name}} ({{(file.size / 1098304).toFixed(2)}} MB)
                        </p>
                    </ng-container>
                </div>
                <div>
                    <p (click)="removeProjectAttachments()"
                        style="color: rgba(222, 222, 222, 0.6);font-size: 10px;text-decoration-line: underline;cursor: pointer;">
                        Remove file</p>
                </div>
            </div>
            <p *ngIf="isDocumentTooLarge === true"
                style="color: #f44336; font-size: 14px; margin-top: 0; margin-bottom: 20px">File size cannot exceed
                40MB.</p>
        </div>

        <div style="padding: 32px;">
            <p style="font-size: 14px; line-height: 18px; color: rgba(222, 222, 222, 0.4);">Please note that file name
                can only include letter, number, hyphen, dot, underscore and white space. And
                the
                max length for file name is 255 characters.</p>

            <div class="flex justify-end">
                <button mat-button (click)="save()"
                    style="border: 1px solid #DEDEDE;border-radius: 8px;width: 163px;height: 52px;">Save</button>
            </div>
        </div>

    </div>
</mat-dialog-content>